module.exports = __webpack_public_path__ + "static/media/21.7897a4dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/21.svg
// module id = 134
// module chunks = 0